import { css } from "@emotion/react";

export const webViewFooter = css`
  border-top: 1px solid var(--gray-100);
  background-color: var(--white);
  padding: 24px 16px;
  display: flex;
  justify-content: space-between;
`;

export const companyName = css`
  font-family: Averta;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: var(--gray-500);
`;

export const links = css`
  font-weight: bold;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: -0.2px;
  color: var(--gray-600);
`;
